import React from 'react';
import { useUserRole, hasRole } from '../lib/auth/roles';

export default function RoleGate({ allow = [], fallback = null, children, loadingFallback = null }) {
  const { role, loading } = useUserRole();

  if (loading) return loadingFallback || null;
  if (!hasRole(role, allow)) return fallback || null;
  return <>{children}</>;
}

